<template>
  <div class="enter_innovation_wrap">
    <div class="enter_img">
      <div class="img_tit hidden-xs-only">{{ $t('carbonTreasure.title') }}</div>
      <div class="img_tit hidden-sm-and-up">{{ $t('carbonTreasure.mobileTitle') }}</div>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <!-- 碳技术总监 -->
        <el-card class="job-card" shadow="hover" :header="$t('carbonTreasure.whatIs.carbonTechDirector.title')">
          <!-- 工作内容 -->
          <h2 class="section-title">{{ $t('carbonTreasure.whatIs.carbonTechDirector.coreObjectives.title') }}</h2>
          <ul class="card-list">
            <li
              v-for="(item, index) in $t('carbonTreasure.whatIs.carbonTechDirector.coreObjectives.items')"
              :key="'carbon-core-' + index"
            >
              {{ item }}
            </li>
          </ul>

          <!-- 岗位要求 -->
          <h2 class="section-title">{{ $t('carbonTreasure.whatIs.carbonTechDirector.productScope.title') }}</h2>
          <ul class="card-list">
            <li
              v-for="(item, index) in $t('carbonTreasure.whatIs.carbonTechDirector.productScope.items')"
              :key="'carbon-scope-' + index"
            >
              {{ item }}
            </li>
          </ul>
        </el-card>

        <!-- 项目经理 -->
        <el-card class="job-card" shadow="hover" :header="$t('carbonTreasure.whatIs.projectManager.title')">
          <!-- 工作内容 -->
          <h2 class="section-title">{{ $t('carbonTreasure.whatIs.projectManager.coreObjectives.title') }}</h2>
          <ul class="card-list">
            <li
              v-for="(item, index) in $t('carbonTreasure.whatIs.projectManager.coreObjectives.items')"
              :key="'project-core-' + index"
            >
              {{ item }}
            </li>
          </ul>

          <!-- 岗位要求 -->
          <h2 class="section-title">{{ $t('carbonTreasure.whatIs.projectManager.productScope.title') }}</h2>
          <ul class="card-list">
            <li
              v-for="(item, index) in $t('carbonTreasure.whatIs.projectManager.productScope.items')"
              :key="'project-scope-' + index"
            >
              {{ item }}
            </li>
          </ul>
        </el-card>

        <!-- 合伙人 -->
        <el-card class="job-card" shadow="hover" :header="$t('carbonTreasure.whatIs.partner.title')">
          <!-- 工作内容 -->
          <h2 class="section-title">{{ $t('carbonTreasure.whatIs.partner.coreObjectives.title') }}</h2>
          <ul class="card-list">
            <li
              v-for="(item, index) in $t('carbonTreasure.whatIs.partner.coreObjectives.items')"
              :key="'partner-core-' + index"
            >
              {{ item }}
            </li>
          </ul>

          <!-- 岗位要求 -->
          <h2 class="section-title">{{ $t('carbonTreasure.whatIs.partner.productScope.title') }}</h2>
          <ul class="card-list">
            <li
              v-for="(item, index) in $t('carbonTreasure.whatIs.partner.productScope.items')"
              :key="'partner-scope-' + index"
            >
              {{ item }}
            </li>
          </ul>
        </el-card>
      </div>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  data() {
    return {
      selectName: '1',
      funcCardList: [
        {
          tit: this.$t('carbonTreasure.impacts.cost.title'),
          desc: this.$t('carbonTreasure.impacts.cost.items'),
          bg: require('../../assets/img/bg1.png')
        },
        {
          tit: this.$t('carbonTreasure.impacts.industry.title'),
          desc: this.$t('carbonTreasure.impacts.industry.items'),
          bg: require('../../assets/img/bg2.png')
        },
        {
          tit: this.$t('carbonTreasure.impacts.market.title'),
          desc: this.$t('carbonTreasure.impacts.market.items'),
          bg: require('../../assets/img/bg3.png')
        },
        {
          tit: this.$t('carbonTreasure.impacts.data.title'),
          desc: this.$t('carbonTreasure.impacts.data.items'),
          bg: require('../../assets/img/bg3.png')
        },
      ],
      images_yb: {
        zh: require('@/assets/img/carbon/cbam-yb.png'),
        en: require('@/assets/img/carbon/cbam-yb-en.png')
      },
      images_yzs: {
        zh: require('@/assets/img/carbon/cbam-yzs.png'),
        en: require('@/assets/img/carbon/cbam-yzs-en.png')
      },
      images_bg: {
        zh: require('@/assets/img/carbon/cbam-bg.png'),
        en: require('@/assets/img/carbon/cbam-bg-en.png')
      }
    }
  },
  computed: {
    ybImg() {
      return this.images_yb[this.$i18n.locale] || this.images_yb.zh;
    },
    yzsImg() {
      return this.images_yzs[this.$i18n.locale] || this.images_yzs.zh;
    },
    bgImg() {
      return this.images_bg[this.$i18n.locale] || this.images_bg.zh;
    },
    isEn() {
      return this.$i18n.locale === 'en'; // 判断当前是否为英文
    },
  },
  watch: {
    '$i18n.locale': {
      handler: 'updateData',
      immediate: true
    }
  },
  methods: {
    getImagePath(index) {
      const suffix = this.isEn ? '-en' : '';
      return require(`@/assets/img/cbam-${index}${suffix}.png`);
    },
    selectMenuItem(name) {
      console.log(name)
    },
    gotoDemo(){
      this.$router.push('/trial')
    },
    updateData() {
      this.funcCardList = [
        {
          tit: this.$t('carbonTreasure.impacts.cost.title'),
          desc: this.$t('carbonTreasure.impacts.cost.items'),
          bg: require('../../assets/img/bg1.png')
        },
        {
          tit: this.$t('carbonTreasure.impacts.industry.title'),
          desc: this.$t('carbonTreasure.impacts.industry.items'),
          bg: require('../../assets/img/bg2.png')
        },
        {
          tit: this.$t('carbonTreasure.impacts.market.title'),
          desc: this.$t('carbonTreasure.impacts.market.items'),
          bg: require('../../assets/img/bg3.png')
        },
        {
          tit: this.$t('carbonTreasure.impacts.data.title'),
          desc: this.$t('carbonTreasure.impacts.data.items'),
          bg: require('../../assets/img/bg3.png')
        },
      ]
    }
  },
  components: {
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;

  .enter_img {
    width: 100%;
    height: 700px;

    @media screen and (max-width: 768px) {
      height: 50vw;
    }

    background: url('../../assets/img/hly/new/关于我们/关于我们.jpg') 0 0 no-repeat;
    background-size: cover;
    background-position: center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;

      @media screen and (max-width: 768px) {
        font-size: 1.8rem;
        text-align: center;
      }
    }
  }

  .production_title_wrap {
    width: 100%;
    padding: 60px 0;
    background-color: #f5f7fa;

    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .production_inner {
      width: 70%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .job-card {
        width: 100%;
        border-radius: 12px;
        padding: 20px;
        background-color: #fff;
        margin-bottom: 30px;

        &:last-child {
          margin-bottom: 0;
        }

        // 修改 el-card header 样式
        ::v-deep(.el-card__header) {
          background-color: #e6f0ff !important;
          font-size: 26px;
          font-weight: bold;
          color: #303133;
          padding: 18px 20px;

          @media screen and (max-width: 768px) {
            font-size: 16px;
            text-align: center;
          }
        }
        .section-title {
          font-size: 22px;
          font-weight: bold;
          margin-top: 20px;
          margin-bottom: 10px;
          color: #303133;
          @media screen and (max-width: 768px) {
            font-size: 16px;
            text-align: left;
          }
        }

        .card-list {
          list-style-type: disc;
          padding-left: 1.5rem;
          font-size: 18px;
          line-height: 2.2rem;
          color: #606266;

          @media screen and (max-width: 768px) {
            font-size: 14px;
            line-height: 1.6rem;
          }
        }
      }
    }
  }
}
</style>
